import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeLang } from "../../redux/slices/langSlice";
import { motion, AnimatePresence } from "framer-motion";
import { IoChevronDown } from "react-icons/io5";
import { useDirection } from "../../utilities/direction";

const LanguageSelection = () => {
  const [modal, setModal] = useState(false);
  const lang = useSelector((state) => state.lang.lang);
  const dispatch = useDispatch();
  const langRef = useRef(null);
  const changeDirection = useDirection();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (langRef.current && !langRef.current.contains(event.target)) {
        setModal(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setModal]);

  const handleLanguageChange = async (language) => {
    changeDirection();
    await dispatch(changeLang(language));
    setModal(false);
  };

  return (

    <li className="language-selection" ref={langRef}>
      <div
        className="selected"
        style={{
          cursor: "pointer",
          opacity: "0.6",
          alignItems: "center",
          display: "flex",
        }}
        onClick={() => setModal(!modal)}
      >
        <div>
          <span>{lang === "tr" ? "TR" : "EN"}</span>
        </div>
        <motion.div animate={{ rotate: 0 }} transition={{ duration: 0.3 }}>
          <IoChevronDown size={30} />
        </motion.div>
      </div>

      <AnimatePresence>
        {modal && (
          <motion.ul
            className="lang-list"
            initial={{ opacity: 0, y: -10, height: 0 }}
            animate={{ opacity: 1, y: 0, height: "auto" }}
            exit={{ opacity: 0, y: -10, height: 0 }}
            transition={{ duration: 0.3 }}
            style={{ overflow: "hidden", transformOrigin: "top" }}
          >
            <li
              className={lang === "tr" ? "active lang-item" : "lang-item"}
              onClick={() => handleLanguageChange("tr")}
            >
              <div>
                <span>TR</span>
              </div>
            </li>
            <li
              className={lang === "en" ? "active lang-item" : "lang-item"}
              onClick={() => handleLanguageChange("en")}
            >
              <div>
                <span>EN</span>
              </div>
            </li>
          </motion.ul>
        )}
      </AnimatePresence>
    </li>

  );
};

export default LanguageSelection;
